const OVERLAY_SELECTOR = '.card-container.popup-shown, .quick-menu-overlay, .ai-debugger-overlay, body > .menu, .ts-panel, .p-datepicker:not(.p-datepicker-inline), .p-dropdown-panel, .p-multiselect-panel';
const EDITABLE_SELECTOR = 'input, textarea, select, [contenteditable]:not([contenteditable="false"])';
const SHORTCUT_TARGETS = {
    a: '[data-shortcut-add]:not(:disabled)',
    f: '[data-shortcut-search] .search-bar input:not(:disabled)'
};

function firstVisible(selector) {
    return Array.from(document.querySelectorAll(selector)).find(element => element.offsetParent !== null) || null;
}

export function handlePageShortcut(event) {
    if (!(event.metaKey || event.ctrlKey) || event.altKey || event.shiftKey || event.defaultPrevented) return;
    const key = String(event.key).toLowerCase();
    const selector = SHORTCUT_TARGETS[key];
    if (!selector || document.querySelector(OVERLAY_SELECTOR)) return;
    if (key === 'a' && event.target?.closest?.(EDITABLE_SELECTOR)) return;

    const target = firstVisible(selector);
    if (!target) return;
    event.preventDefault();
    if (key === 'a') {
        target.click();
        return;
    }
    target.focus();
    target.select();
}
